import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import ScrollToTop from "./Component/ScrollToTop";
import Seo from "./Component/Seo";
import NotFound from "./Component/NotFound";
import ErrorBoundary from "./Component/ErrorBoundary";
import Faqs from "./Component/Faqs";
import Cookies from "./Component/Cookies";
import {
  additionalPolicyRoutes,
  CommercePolicy,
  PolicyCentre,
} from "./Component/CommercePolicies";

function App() {
  return (
    <ErrorBoundary>
      <CartProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <Seo />
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/policies" element={<PolicyCentre />} />
          {additionalPolicyRoutes.map(({ key, path }) => (
            <Route
              key={key}
              path={path}
              element={<CommercePolicy policyKey={key} />}
            />
          ))}
          <Route path="/payment" element={<PaySuccess />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        </Router>
      </CartProvider>
    </ErrorBoundary>
  );
}

export default App;
